/**
 * Check-In Analytics sagas
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { httpRequest } from '../../services/http-service';
import { endPoints } from '../../services/endpoints';
import {
  fetchCheckInAnalytics,
  setCheckInAnalytics,
  setLoading,
  setError,
} from './checkInAnalyticsSlice';
import { presentLoader, dismissLoader } from './commonSlice';

/**
 * Fetch check-in analytics saga
 */
function* fetchCheckInAnalyticsSaga(): Generator<any, void, any> {
  try {
    yield put(presentLoader());
    yield put(setLoading(true));

    const response = yield call(httpRequest.get, endPoints.dashboard.checkinAnalytics);

    if (response?.success) {
      yield put(setCheckInAnalytics(response.data));
    } else {
      toast.error('Failed to fetch check-in analytics');
      yield put(setError('Failed to fetch check-in analytics'));
    }
  } catch (error: any) {
    const message = error?.message || 'Failed to fetch check-in analytics';
    toast.error(message);
    yield put(setError(message));
  } finally {
    yield put(setLoading(false));
    yield put(dismissLoader());
  }
}

export function* checkInAnalyticsSagas(): Generator<any, void, any> {
  yield takeLatest(fetchCheckInAnalytics, fetchCheckInAnalyticsSaga);
}

